import type { LiveOddsCandidateScope } from './types'
import { queryOptions } from '@tanstack/react-query'

import { getLiveOddsReadiness, listLiveOddsCandidates } from './api'

export function liveOddsReadinessQueryOptions(scope?: LiveOddsCandidateScope) {
  return queryOptions({
    queryKey: ['live-odds', 'readiness', scope ?? null],
    queryFn: () => getLiveOddsReadiness(scope),
  })
}

export function liveOddsCandidatesQueryOptions(scope?: LiveOddsCandidateScope) {
  return queryOptions({
    queryKey: ['live-odds', 'candidates', 'pending', scope ?? null],
    queryFn: () => listLiveOddsCandidates('pending', scope),
  })
}
